import helper from 'store/helper';
import types from './types';

export const initialState = {
  isEnabled: false,
  isLoading: false,
  isChecked: false,
};

const setAdebifyEnabled = (state, action) => {
  const { isEnabled } = action.payload;
  return {
    ...state,
    isEnabled,
    isLoading: false,
    isChecked: true,
  };
};

const setAdebifyLoading = (state, action) => {
  const { isLoading } = action.payload;
  return {
    ...state,
    isLoading,
  };
};

const AdebifyReducer = helper.createReducer(initialState, {
  [types.SET_ADEBIFY_ENABLED]: setAdebifyEnabled,
  [types.SET_ADEBIFY_LOADING]: setAdebifyLoading,
});

export default AdebifyReducer;
